import Modal from "../../../../components/common/form/Modal";
import { ModalProps } from "../../../../helpers/constants";
import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { booleanChecks, createOptionListForSelectTag, isNullOrEmpty } from "../../../../helpers/utils/Utils";
import SelectField from "../../../../components/common/form/SelectField";
import { priorityCategories } from "../../../../enums/common";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAllRegularCustomersQuery } from "../../../customer/customerApi";
import { useGetBranchesByCustomerIdsQuery } from "../../../customer/branchApi";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { useCreateTeamRuleMutation, useGetTeamRuleByIdQuery, useUpdateTeamRuleMutation } from "../teamsApi";
import { useGetMetroAreaByStateIdsQuery } from "../../../data/metroAreas/metroAreasApi";
import { useParams } from "react-router-dom";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { selectStyle } from "../../../../helpers/utils/StyleUtils";
import Select from "react-select";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useLazyGetCountiesByStateIdsQuery } from "../../../data/counties/countiesApi";
import InputField from "../../../../components/common/form/InputField";
import { tgxApi } from "../../../../app/tgxApi";
import { useDispatch } from "react-redux";

interface props extends ModalProps {
    teamRuleId?: string | undefined,
    title: string,
    btnText: string
}

const AddUpdateRule: FC<props> = ({ teamRuleId, btnText, title, show, setShow }) => {

    let { teamId } = useParams();
    const dispatch = useDispatch();

    const [ruleData, setRuleData] = useState<any>({});
    const [updatedBranches, setUpdatedBranches] = useState<any>([]);
    const [updatedCounties, setUpdatedCounties] = useState<any>([]);
    const statesApiResult = useGetAllStatesQuery("");
    const customerApiResult = useGetAllRegularCustomersQuery("");
    const teamRuleByIdApiResult = useGetTeamRuleByIdQuery(teamRuleId);
    const { data: enums } = useGetEnumsQuery("");
    const branchesApiResult = useGetBranchesByCustomerIdsQuery(ruleData?.customers ? ruleData?.customers?.map((el: any) => {
        return el.value
    }) : skipToken);
    const [createTeamRuleApi, createTeamRuleApiResponse] = useCreateTeamRuleMutation();
    const [updateTeamRuleApi, updateTeamRuleApiResponse] = useUpdateTeamRuleMutation();
    const [states, setStates] = useState<any>([]);
    const metroAreaByStateAbbr = useGetMetroAreaByStateIdsQuery(states || skipToken);
    const [weight, setWeight] = useState<any>(null);


    const [low, setLow] = useState({
        "name": "Low",
        "min": 1,
        "max": 100,
    });

    const [medium, setMedium] = useState({
        "name": "Medium",
        "min": 101,
        "max": 500,
    });

    const [high, setHigh] = useState({
        "name": "High",
        "min": 501,
        "max": 1000,
    });

    const [extreme, setExtreme] = useState({
        "name": "Extreme",
        "min": 1001,
        "max": null,
    });

    const getCategoryForWeight = (weight: any) => weight <= low.max ? low : weight >= medium.min && weight <= medium.max ? medium : weight >= high.min && weight <= high.max ? high : extreme;

    const getCategoryByName = (name: any) => [low, medium, high, extreme].find(entry => entry.name === name)
    const selectedCategory = getCategoryByName(ruleData.category);
    const [countiesApiResultApi, countiesApiResult] = useLazyGetCountiesByStateIdsQuery();

    useEffect(() => {
        setRuleData({});
        dispatch(tgxApi.util.invalidateTags(["countiesByStateIds", "teamRuleById"]));
    }, []);


    useEffect(() => {
        countiesApiResultApi(states)
    }, [states]);

    useEffect(() => {
        let obj = teamRuleByIdApiResult?.data;

        if (obj) {
            let ruleQueryParameters = obj?.ruleQueryParameters;
            const initialRuleData: any = {
                customerOrderNumberPattern: ruleQueryParameters?.customerOrderNumberPattern,
                category: {
                    value: getCategoryForWeight(obj?.weight)?.name,
                    label: getCategoryForWeight(obj?.weight).name
                },
                productTypes: ruleQueryParameters?.productTypes?.map((el: any) => {
                    return {
                        value: el,
                        label: getEnumDisplayNameByConstant(enums?.["ProductType"], el)
                    }
                }),
                productStatuses: ruleQueryParameters?.productStatuses?.map((el: any) => {
                    return {
                        value: el,
                        label: getEnumDisplayNameByConstant(enums?.["ProductStatus"], el)
                    }
                }),
                orderStatus: ruleQueryParameters?.orderStatuses?.map((el: any) => {
                    return {
                        value: el,
                        label: getEnumDisplayNameByConstant(enums?.["OrderStatus"], el)
                    }
                }),
                stateId: ruleQueryParameters?.states
                    ? ruleQueryParameters?.states?.map((stateId: string) => {
                        const matchedState = statesApiResult?.data?.find((obj: any) => obj.id === stateId);
                        return {
                            value: stateId,
                            label: matchedState?.stateName || '',
                        };
                    })
                    : [],

                metroAreaId: ruleQueryParameters?.metroArea ?
                    {
                        label: ruleQueryParameters?.metroArea,
                        value: metroAreaByStateAbbr?.data?.map((el: any) => el.name.toLowerCase() === ruleQueryParameters?.metroArea.toLowerCase()).id
                    } : null,

                minimumOrderAge: ruleQueryParameters?.minimumOrderAge,
                minimumOrderAgeType: ruleQueryParameters?.minimumOrderAgeType ? {
                    value: ruleQueryParameters?.minimumOrderAgeType,
                    label: getEnumDisplayNameByConstant(
                        enums?.["OrderAgeType"],
                        ruleQueryParameters?.minimumOrderAgeType
                    )
                } : null,
                customers: obj?.customers?.map((el: any) => {
                    return {
                        value: el?.id,
                        label: el?.customerName
                    };
                }),
                branches: obj?.branches?.map((el: any) => {
                    return {
                        value: el?.id,
                        label: el?.name
                    };
                }),
                teamId: teamId,
                rush: ruleQueryParameters?.rush ? {
                    value: ruleQueryParameters?.rush,
                    label: booleanChecks?.find((el: any) => el.value === ruleQueryParameters?.rush)?.label || '',
                } : null,
                hasError: ruleQueryParameters?.hasError ? {
                    value: ruleQueryParameters?.hasError,
                    label: booleanChecks?.find((el: any) => el?.value === ruleQueryParameters?.hasError)?.label || '',
                } : null,
            }

            if (countiesApiResult?.data && ruleQueryParameters?.counties) {
                initialRuleData.countyId = ruleQueryParameters?.counties
                    ? ruleQueryParameters?.counties?.map((countyId: string) => {
                        const matchedCounty = countiesApiResult?.data?.find((obj: any) => obj.id === countyId);
                        return {
                            value: countyId,
                            label: matchedCounty?.countyName || '',
                        };
                    }) : [];
            } else {
                countiesApiResultApi(ruleQueryParameters?.states);
                initialRuleData.countyId = [
                    {
                        value: ruleQueryParameters?.counties?.map((el: any) => el),
                    },
                ];
            }
            setRuleData(initialRuleData)
            setStates(ruleQueryParameters?.states)
            setWeight(obj.weight)
        }

    }, [teamRuleByIdApiResult]);

    useEffect(() => {
        if (ruleData) {
            if (countiesApiResult?.data && ruleData?.stateId && ruleData?.countyId) {
                const countyOptions = Array.isArray(ruleData?.countyId)
                ? ruleData.countyId.map((county: any) => {
                    const id = typeof county === 'string' ? county : county?.value;
                    const matchedCounty = countiesApiResult?.data?.find(
                      (obj: any) => obj.id?.toLowerCase() === id?.toLowerCase()
                    );
                    return {
                      value: id,
                      label: matchedCounty?.countyName || '', // Replace with correct field
                    };
                  })
                : [];
                setRuleData({
                    ...ruleData,
                    countyId: countyOptions,
                })
            } else {
                setRuleData({
                    ...ruleData,
                    countyId: null,
                })
            }
        }
    }, [countiesApiResult?.data]);

    useEffect(() => {
        if (branchesApiResult?.data && customerApiResult?.data && ruleData?.customers) {
            const updatedBranches = branchesApiResult.data?.map((el: any) => {
                const customer = customerApiResult.data?.find((customer: any) => customer.id === el.customerId);
                return {
                    ...el,
                    customerName: customer ? customer.customerName : "Unknown",
                };
            });
            setUpdatedBranches(updatedBranches);
        }
    }, [branchesApiResult?.data, customerApiResult?.data]);

    useEffect(() => {
        if (countiesApiResult?.data && statesApiResult?.data && ruleData?.stateId) {
            const updatedCounties = countiesApiResult.data?.map((el: any) => {
                const stateData = statesApiResult.data?.find((state: any) => state.id === el.state.id);
                return {
                    ...el,
                    stateAbbreviation: stateData ? stateData.stateAbbreviation : "Unknown", // Assuming `customer.name` exists
                };
            });
            setUpdatedCounties(updatedCounties); // Replace with your state setter
        }
    }, [countiesApiResult?.data, statesApiResult?.data]);


    useEffect(() => {
        if (ruleData?.stateId?.value) {
            setRuleData(
                {
                    ...ruleData,
                    county: null,
                    metroArea: null
                }
            )
        }
    }, [ruleData?.stateId]);

    useEffect(() => {
        if (ruleData?.customers?.length === 0) {
            setRuleData(
                {
                    ...ruleData,
                    branches: null
                }
            )
        }
    }, [ruleData?.customers]);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | {
        name: string;
        value: any
    } | ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = "target" in e ? e.target : e;
        setRuleData((prev: any) => {
            const updatedData = { ...prev, [name]: value };

            if (name === "metroAreaId") {
                updatedData.countyId = null;
            } else if (name === "countyId") {
                updatedData.metroAreaId = null;
            } else if (name === "stateId") {
                updatedData.metroAreaId = null;
                updatedData.countyId = null;
            }

            return updatedData;
        });
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let categoryForName = getCategoryByName(ruleData.category?.value);
        let obj = {
            weight: weight,
            ruleQueryParameters: {
                productTypes: ruleData?.productTypes?.map((el: any) => {
                    return el.value
                }),
                productStatuses: ruleData?.productStatuses?.map((el: any) => {
                    return el.value
                }),
                states: ruleData?.stateId?.map((el: any) => {
                    return el.value
                }),
                counties: ruleData?.countyId?.map((el: any) => {
                    return el.value
                }),
                metroArea: ruleData?.metroAreaId?.label,
                minimumOrderAge: ruleData?.minimumOrderAge,
                minimumOrderAgeType: ruleData?.minimumOrderAgeType?.value,
                customerOrderNumberPattern: ruleData?.customerOrderNumberPattern,
                hasError: ruleData?.hasError?.value,
                orderStatuses: ruleData?.orderStatus?.map((el: any) => {
                    return el.value
                }),
                rush: ruleData?.rush?.value
            },

            customers: ruleData?.customers?.map((el: any) => {
                return {
                    id: el.value,
                };
            }),
            branches: ruleData?.branches?.map((el: any) => {
                return {
                    id: el.value,
                };
            }),

            teamId: teamId
        }


        const createOrUpdateRule = async () => {
            if (btnText === "Create") {
                await createTeamRuleApi(obj).unwrap();
            } else {
                await updateTeamRuleApi({
                    id: teamRuleId,
                    requestBody: obj,
                }).unwrap();
            }
        };

        await handleRTKQuery(createOrUpdateRule, () => {

            setShow(false);
        });
    }


    return (
        <>
            <Modal title={title} show={show} setShow={setShow} className={"w-2/5"}
                fields={
                    <Form onSubmit={handleSubmit} fields={
                        <>

                            <SelectField
                                label="Category"
                                options={createOptionListForSelectTag(priorityCategories, "value", "constant")}
                                value={ruleData.category || null}
                                placeholder="Select Category..."
                                onChange={(selectedOption) => {
                                    handleOnChange({
                                        name: "category",
                                        value: selectedOption
                                    });

                                    const categoryForName = getCategoryByName(selectedOption?.value);
                                    setWeight(categoryForName ? categoryForName.min : '');
                                }}

                                required={true}
                            />
                            {ruleData.category &&
                                <InputField className="form-control" value={weight} type="number"
                                    name="weight"
                                    minLength={selectedCategory?.min ?? 0}
                                    maxLength={selectedCategory?.max ?? 9999}
                                    onChange={(e) => {
                                        setWeight(e.target.value);
                                    }}
                                    placeholder="Enter Weight..."
                                    required={true} label="Priority" />
                            }
                            <SelectField
                                label="Product Type"
                                options={createOptionListForSelectTag(enums?.["ProductType"], "value", "constant")}
                                value={ruleData.productTypes || null}
                                placeholder="Select Product Type..."
                                onChange={(selectedOption) => handleOnChange({
                                    name: "productTypes",
                                    value: selectedOption
                                })}
                                isMulti={true}
                                required={true}
                            />
                            <SelectField
                                label="Order Status"
                                options={createOptionListForSelectTag(enums?.["OrderStatus"], "value", "constant")}
                                value={ruleData.orderStatus || null}
                                placeholder="Select order status..."
                                onChange={(selectedOption) => handleOnChange({
                                    name: "orderStatus",
                                    value: selectedOption
                                })}
                                isMulti={true}
                            />

                            <SelectField
                                label="Product Status"
                                options={createOptionListForSelectTag(enums?.["ProductStatus"], "value", "constant")}
                                value={ruleData.productStatuses || null}
                                placeholder="Select Product Status..."
                                onChange={(selectedOption) => handleOnChange({
                                    name: "productStatuses",
                                    value: selectedOption
                                })}
                                isMulti={true}
                            />
                            <SelectField
                                label="State"
                                options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "id")}
                                value={ruleData.stateId || []}
                                placeholder="Select State..."
                                isMulti
                                onChange={(selectedOptions) => {
                                    handleOnChange({
                                        name: "stateId",
                                        value: selectedOptions
                                    });
                                    const selectedArray = Array.isArray(selectedOptions) ? selectedOptions : [];
                                    const selectedIds = selectedArray.map((opt) => opt.value);
                                    setStates(selectedIds);
                                }}
                            />
                            <SelectField
                                label="County"
                                value={ruleData?.countyId}
                                placeholder="Select County..."
                                options={createOptionListForSelectTag(updatedCounties, "countyName", "id", "stateAbbreviation")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "countyId", value: selectedOption })
                                }}
                                isDisabled={!countiesApiResult?.data || countiesApiResult.data.length === 0}
                                isLoading={countiesApiResult?.isLoading || countiesApiResult?.isFetching}
                                isMulti

                            />

                            <SelectField
                                label="Metro Area"
                                value={ruleData?.metroAreaId}
                                placeholder="Select Metro Area..."
                                options={createOptionListForSelectTag(metroAreaByStateAbbr?.data, "name", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "metroAreaId", value: selectedOption })
                                }}
                                isDisabled={!metroAreaByStateAbbr.data || metroAreaByStateAbbr.data.length === 0}
                                isLoading={metroAreaByStateAbbr?.isLoading || metroAreaByStateAbbr?.isFetching}
                            />

                            <SelectField
                                label="Customer"
                                value={ruleData?.customers}
                                placeholder="Select Customer..."
                                options={createOptionListForSelectTag(customerApiResult?.data, "customerName", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "customers", value: selectedOption })
                                }}
                                isMulti={true}
                            />

                            <SelectField
                                label="Branch"
                                value={ruleData?.branches || null}
                                placeholder="Select Branch..."
                                options={createOptionListForSelectTag(updatedBranches, "name", "id", "customerName")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "branches", value: selectedOption })
                                }}
                                isMulti={true}
                                isLoading={isNullOrEmpty(ruleData?.customers)}
                            />

                            <SelectField
                                label="Is Rush"
                                options={createOptionListForSelectTag(booleanChecks, "label", "value")}
                                value={ruleData.rush || null}
                                placeholder="Select Rush..."
                                onChange={(selectedOption) => handleOnChange({
                                    name: "rush",
                                    value: selectedOption
                                })}
                            />
                            <SelectField
                                label="Has Error"
                                options={createOptionListForSelectTag(booleanChecks, "label", "value")}
                                value={ruleData.hasError || null}
                                placeholder="Select Has Error..."
                                onChange={(selectedOption) => handleOnChange({
                                    name: "hasError",
                                    value: selectedOption
                                })}
                            />
                            <div className={"col-span-12 md:grid md:grid-cols-12 gap-3"}>

                                <div className="col-span-3 sm:mt-2 lg-mt-0 mt-2 flex items-center">
                                    <div className="text-surface-0">Min Order Age</div>
                                </div>

                                <div className={"col-span-4 flex gap-3"}>
                                    <input placeholder="Enter Min Order Age.hh.."
                                        type={"number"} value={ruleData.minimumOrderAge}
                                        className={"placeholder:text-text-2 rounded-md border border-3 border-surface-5 p-2 w-full mt-3"}
                                        name={"minimumOrderAge"}
                                        onChange={handleOnChange}
                                    />
                                </div>

                                <div className={"col-span-5 mt-3.5"}>
                                    <Select
                                        styles={selectStyle}
                                        onChange={(selectedOption) => {
                                            handleOnChange({ name: "minimumOrderAgeType", value: selectedOption })
                                        }}
                                        value={ruleData?.minimumOrderAgeType || null}
                                        isClearable={true}
                                        options={createOptionListForSelectTag(enums?.['OrderAgeType'], "value", "constant")}
                                        placeholder={"Select Unit..."}
                                    />
                                </div>

                            </div>
                            <InputField type="text"
                                placeholder='Enter Order No. Pattern...'
                                value={ruleData.customerOrderNumberPattern}
                                onChange={handleOnChange}
                                name="customerOrderNumberPattern"
                                label="Order No. Pattern"
                            />
                            <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>

                            </div>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            type: "submit",
                                            isLoading: (createTeamRuleApiResponse.isLoading || updateTeamRuleApiResponse.isLoading),
                                        },
                                        buttonType: "button",

                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />
                        </>}
                    />
                }
            />
        </>
    )
}

export default AddUpdateRule;